import React, { useState, useEffect, useRef } from "react";
import {
  converteCodigo,
  trataAtleta,
  trataInicio,
  separaBlocos,
} from "./utils";
import GravarBlocos from "./GravaBlocos";

const Inputs = ({
  set,
  sacador,
  homeNumbers,
  visitorNumbers,
  lastScout,
  idPartida,
  firstScout,
  parametros,
  homeLeft,
  onScoutUpdate,
  placar,
  onRefresh,
}) => {
  const [codigos, setCodigos] = useState("");
  const [atletas, setAtletas] = useState([]);
  const [digitado, setDigitado] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [lista, setLista] = useState([]);
  const [saque, setSaque] = useState(sacador);
  const [setAtual, setSetAtual] = useState(false);

  const inputRef = useRef(null);
  const [shouldUpdateInput, setShouldUpdateInput] = useState(true);

  useEffect(() => {
    if (shouldUpdateInput) {
      if (sacador === "*" && homeNumbers) {
        setDigitado(homeNumbers[0] + "S" || "");
      } else if (sacador === "a" && visitorNumbers) {
        setDigitado(sacador.toUpperCase() + visitorNumbers[0] + "S" || "");
      }
    }
  }, [sacador, homeNumbers, visitorNumbers, placar]);

  useEffect(() => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
        const len = inputRef.current.value.length;
        inputRef.current.setSelectionRange(len, len);
      }, 0);
    }
  }, [digitado]);

  const handleCodes = (e) => {
    setShouldUpdateInput(false);
    const valorDigitado = e.target.value;
    setDigitado(valorDigitado.toUpperCase() || "");
    const novoCodigo = trataInicio(valorDigitado);
    setCodigos(novoCodigo);
    setAtletas([trataAtleta(novoCodigo)]);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setIsLoading(true);
      setError(null);

      try {
        const blocos = digitado.split(" ");
        const blocosComPontos = separaBlocos(blocos);
        setLista(blocosComPontos);

        const atletasProcessados = blocosComPontos.map((bloco) =>
          converteCodigo(bloco)
        );
        setAtletas(atletasProcessados);

        await GravarBlocos(
          atletasProcessados,
          lastScout,
          idPartida,
          set,
          firstScout,
          parametros,
          homeLeft
        );

        // Limpa o input e notifica o componente pai para atualizar os dados
        setDigitado("");
        setLista([]);
        setAtletas([]);
        setShouldUpdateInput(true);
        if (onScoutUpdate) {
          onScoutUpdate();
        }
        if (onRefresh) {
          onRefresh();
        }
      } catch (error) {
        console.error("Erro ao gravar blocos:", error);
        setError("Erro ao gravar os dados. Tente novamente.");
      } finally {
        setIsLoading(false);
      }
    } else if ((e.ctrlKey || e.metaKey) && e.key === "z") {
      e.preventDefault();

      setLista((prevLista) => {
        const novaLista = [...prevLista];
        novaLista.pop();
        return novaLista;
      });

      setDigitado((prevDigitado) => {
        const blocos = prevDigitado.split(" ");
        blocos.pop();
        return blocos.join(" ");
      });
    } else {
      const blocos = digitado.split(" ");
      setLista(blocos);
      const atletasProcessados = blocos.map((bloco) => converteCodigo(bloco));
      setAtletas(atletasProcessados);
    }
  };

  return (
    <div>
      <input
        ref={inputRef}
        id="code"
        type="text"
        value={digitado}
        onChange={handleCodes}
        onKeyDown={handleKeyDown}
        className="border border-gray-400 px-4 py-2 w-full rounded-md mt-8"
        required
        disabled={isLoading}
      />
      {error && <div className="text-red-600 mt-2 text-sm">{error}</div>}
      {isLoading && (
        <div className="text-gray-600 mt-2 text-sm">Salvando...</div>
      )}
    </div>
  );
};

export default Inputs;
